import React from 'react'
import './landing.css'

function Landing() {
    return(
        <div className = "big-div">
            <div className = "div-two">
                <div className = "landing-img">
                    {/* <img src = {LandingImg} className = "landing-svg" /> */}
                </div>
                <div className = "landing-title">
                    <h1>Pathshala</h1>
                </div>
            </div>
        </div>
    )
}

export default Landing